import type { SVGProps } from "react";
export default function SvgCheckFull(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 14 14"
			{...props}
		>
			<path
				fill="currentColor"
				d="M10 .893a6.666 6.666 0 1 1-9.997 5.99L0 6.667l.003-.216A6.667 6.667 0 0 1 10 .893m-.862 3.969a.67.67 0 0 0-.88-.055l-.063.055L6 7.057l-.862-.862-.063-.055a.667.667 0 0 0-.935.935l.055.063L5.53 8.47l.062.056a.67.67 0 0 0 .818 0l.062-.056 2.667-2.666.055-.063a.67.67 0 0 0-.055-.88"
			/>
		</svg>
	);
}
